export default {"src":"/_next/static/media/HNST.93680616.svg","height":18,"width":18};